module.exports = __webpack_public_path__ + "img/mileage.852347aa.svg";